import { Component, Input, OnInit, ViewChild, ElementRef, SimpleChanges } from '@angular/core';
import { IFile, IProduct, IVariant, ICurrencyPrice } from '../../../models/products.models';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { EditBasicProductInfosComponent } from '../../edit-product/edit-basic-product-infos/edit-basic-product-infos.component';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/core/app.state';
import { Actions, ofType } from '@ngrx/effects';
import { ImproveVariantsProduct, UpdateProduct, UpdateProductSuccess } from '../../../store/produits.actions';
import { BehaviorSubject, of, Observable, Subscription, tap, combineLatest, startWith, map } from 'rxjs';
import { FetchAllBrands } from 'src/app/features/brands/store/brands.actions';
import { IBrand } from 'src/app/features/brands/models/brands.models';
import { DetailsDialogEditsPricingComponent } from '../../details-dialog-edits-pricing/details-dialog-edits-pricing.component';
import { DetailsTechnicalDialogEditsComponent } from '../../details-technical-dialog-edits/details-technical-dialog-edits.component';
import { DetailsSettingDialogEditsComponent } from '../../details-setting-dialog-edits/details-setting-dialog-edits.component';
import { FetchAllCurrencies } from 'src/app/features/customers/store/customers.actions';
import { ICategory } from 'src/app/features/categories/models/categories.models';
import { ITag } from 'src/app/features/tags/models/tags.models';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ENTER, COMMA } from '@angular/cdk/keycodes';
import { EditVariantProductInfosComponent } from '../../edit-product/edit-variant-product-infos/edit-variant-product-infos.component';
import { EditVariantProductPricingComponent } from '../../edit-product/edit-variant-product-pricing/edit-variant-product-pricing.component';
import { EditVariantProductSettingsComponent } from '../../edit-product/edit-variant-product-settings/edit-variant-product-settings.component';
import { IObjectCustomFields, IObjectCustomFieldsParams } from 'src/app/features/settings/models/settings.models';
import { CustomFieldVisibilityTypes, RelatedObjectsTypes } from 'src/app/features/settings/models/custom-fields.constants';
import { GetObjectCustomFields, UpdateObjectCustomFields } from 'src/app/features/settings/store/settings.actions';
import { LanguageService } from 'src/app/config/language.service';
import { InventoryCustomFieldsComponent } from '../../inventory-custom-fields/inventory-custom-fields.component';
import { selectCanDo } from 'src/app/core/store/permissions/permissions.selectors';
import { selectIsFieldVisible } from 'src/app/core/store/field-visibility/field-visibility.selectors';
import { productStatusI18nKey, productStatusTone } from '../../../utils/product-status';
import { StatusBadgeTone } from 'src/app/ui/status-badge/status-badge.component';
@Component({
  selector: 'app-product-informations',
  templateUrl: './product-informations.component.html',
  styleUrls: ['./product-informations.component.scss']
})
export class ProductInformationsComponent implements OnInit {

  @Input() product!: IProduct;

  // Read more functionality
  isDescriptionExpanded = false;
  isTechnicalDetailsExpanded = false;
  readonly DESCRIPTION_TRUNCATE_LENGTH = 80;

  // Image slideshow functionality
  currentImageIndex = 0;
  apiBaseUrl = environment.BASE_URL_API;

  brand_id: number | undefined;

  selectedValues: { [key: string]: string } = {};
  selectedVariant: IVariant | undefined = undefined;
  selectedFiles: IFile[] = [];
  tags$: Observable<ITag[]> = of([]);
  filteredTags$!: Observable<ITag[]>;
  categories$: Observable<ICategory[]> = of([]);
  filteredCategories$!: Observable<ICategory[]>;
  categories!: Array<ICategory>
  categoriesSelected$ = new BehaviorSubject<ICategory[]>([]);
  tagsSelected$ = new BehaviorSubject<ITag[]>([]);
  form!: FormGroup;
  readonly separatorKeysCodes = [ENTER, COMMA] as const;
  objectCustomFieldsParams: IObjectCustomFieldsParams = {
    object_type: RelatedObjectsTypes.INVENTORY,
    record_id: 0,
    visibility: [CustomFieldVisibilityTypes.BACKOFFICE],
    include_definitions: true,
  };
  objectCustomFields$: Observable<IObjectCustomFields | null> = this.store.select(state => state.settings.objectCustomFields);
  canEditProduct$ = this.store.select(selectCanDo('product', 'edit'));
  objectCustomFields: IObjectCustomFields | null = null;
  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;
  @ViewChild('documentInput') documentInput!: ElementRef<HTMLInputElement>;
  productImages: { image: string, default: boolean }[] = [];
  private subscriptions: Subscription[] = [];
  currentLanguage: string = this.languageService.getCurrentLanguage();
  
  isPricingVisible$: Observable<boolean> = combineLatest([this.store.select(selectIsFieldVisible('product', 'sales_price')), this.store.select(selectIsFieldVisible('product', 'cost'))]).pipe(
    map(([isSalesPriceVisible, isCostVisible]) => isSalesPriceVisible && isCostVisible),
    startWith(false)
  );

  constructor(
    private translateService: TranslateService, 
    private dialog: MatDialog, 
    private store: Store<AppState>,
    private actions$: Actions,
    private fb: FormBuilder,
    private languageService: LanguageService
  ) { 
    this.tags$ = this.store.select((state) => [...state.tags.allTags].sort((a, b) => a.name.localeCompare(b.name)));
    this.categories$ = this.store.select((state) => [...state.categories.allCategories].sort((a, b) => a.name.localeCompare(b.name)))
  }

  ngOnInit(): void {
    this.objectCustomFieldsParams.record_id = this.product.id || 0;
    this.initializeForm();
    this.store.dispatch(FetchAllBrands({}));
    this.store.dispatch(FetchAllCurrencies());
    this.store.dispatch(GetObjectCustomFields({ params: this.objectCustomFieldsParams }));
    if(this.product.variants && this.product.variants.length > 0 && this.product.attributes && this.product.attributes.length > 0){
      this.product.attributes?.forEach((attribute) => {
        this.selectedValues[attribute.name] = attribute.values[0];
      });
      this.updateSelectedVariant();
    }


    const sub0 = this.actions$.pipe(
      ofType(UpdateProductSuccess),
      tap((action) => {

      })).subscribe();

    const sub1 = this.objectCustomFields$.subscribe((objectCustomFields) => {
      this.objectCustomFields = objectCustomFields;
    });

    this.subscriptions.push(sub0, sub1);

    this.categoriesSelected$.next(this.product.categories || []);
    this.tagsSelected$.next(this.product.tags || []);
    this.selectedFiles = this.product.files?.map((file: IFile) => ({
      data: file.data,
      filename: file.filename,
      content_type: file.content_type,
    })) || [];


    this.filteredCategories$ = combineLatest([
      this.categories$,
      this.categoriesSelected$,
      this.form.get('categoryControl')!.valueChanges.pipe(startWith(''))
    ]).pipe(
      map(([allCategories, selected, search]) => {
        const searchLower = search?.toLowerCase() || '';
        return allCategories.filter(cat =>
          cat.name.toLowerCase().includes(searchLower) &&
          !selected.some(sel => sel.id === cat.id)
        );
      })
    );

    this.filteredTags$ = combineLatest([
      this.tags$,
      this.tagsSelected$,
      this.form.get('tagControl')!.valueChanges.pipe(startWith(''))
    ]).pipe(
      map(([allTags, selected, search]) => {
        const searchLower = search?.toLowerCase() || '';
        return allTags.filter(cat =>
          cat.name.toLowerCase().includes(searchLower) &&
          !selected.some(sel => sel.id === cat.id)
        );
      })
    );

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['product']) {
      this.selectedFiles = this.product.files?.map((file: IFile) => ({
        data: file.data,
        filename: file.filename,
        content_type: file.content_type,
      })) || [];
      this.getProductImages();
      this.updateSelectedVariant();
    }
  }

  private initializeForm(): void {
    this.form = this.fb.group({
      categoryControl: [],
      tagControl: [],
    });
  }
  async getProductImages(): Promise<void> {
    this.productImages = [];
    if (this.product.image) {
      this.productImages.push({
        image: (await this.getBase64ImageFromUrlUsingCanvas(this.apiBaseUrl + this.product.image!)).split(',')[1],
        default: true
      });
    }
    
    if (this.product.images && Array.isArray(this.product.images)) {
      this.product.images.forEach(async (img: any) => {
        this.productImages.push({
          image: (await this.getBase64ImageFromUrlUsingCanvas(this.apiBaseUrl + img)).split(',')[1],
          default: false
        });
      });
    }
  }

  onBrandSelected(brand: IBrand) {
    if (brand) {
      this.brand_id = brand.id
    }
  }

  onTagSelected(tag: ITag) {
    if (tag) {
      const current = this.tagsSelected$.getValue();
      if (!current.some(c => c.id === tag.id)) {
        this.tagsSelected$.next([...current, tag]);
      }
    }
    this.form.get('tagControl')?.setValue('');
    this.save("tags", this.tagsSelected$.getValue());
  }

  onChipInputBlur(type: 'tag' | 'category') {
    // Clear the input if user leaves without selecting an item
    // Use setTimeout to allow click events on autocomplete options to process first
    setTimeout(() => {
      this.form.get(type + 'Control')?.setValue('');
    }, 300);
  }

  onCategorySelected(category: ICategory) {
    if (category) {
      const current = this.categoriesSelected$.getValue();
      if (!current.some(c => c.id === category.id)) {
        this.categoriesSelected$.next([...current, category]);
      }
    }
    this.form.get('categoryControl')?.setValue('');
    this.save("categories", this.categoriesSelected$.getValue());
  }

  cancelTag(id: number) {
    const current = this.tagsSelected$.getValue();
    const updated = current.filter(tag => tag.id !== id);
    this.tagsSelected$.next(updated);
    this.save("tags", updated);
  }

  cancelCategory(id: number) {
    const current = this.categoriesSelected$.getValue();
    const updated = current.filter(cat => cat.id !== id);
    this.categoriesSelected$.next(updated);
    this.save("categories", updated);
  }

  getImageUrl(image: string): string {
    if (!image) return '';
    return image.includes('cdn/') ? this.apiBaseUrl + image : `data:'';base64, ${image}`;
  }

  getAllImages(): string[] {
    const images: string[] = [];
    const productType = this.getProductType(this.product);
    // if(productType === 'variant_product'){
    //   images.push(this.getImageUrl(this.selectedVariant?.image ?? ''));
    // } else {
      if (this.product.image) {
        images.push(this.getImageUrl(this.product.image));
      }
      
      // Add other images from images array
      if (this.product.images && Array.isArray(this.product.images)) {
        this.product.images.forEach((img: any) => {
          if (typeof img === 'string') {
            images.push(this.getImageUrl(img));
          } else if (img.preview && !img.isDefault) {
            images.push(img.preview);
          }
        });
      }
    // }
    
    return images.filter(img => img !== ''); // Remove empty strings
  }

  getProductElementValue(element: 'sales_price' | 'cost' | 'sku' | 'erp_id' | 'barcode' | 'min_qte' | 'increment' | 'max_qte'): string {
    const productType = this.getProductType(this.product);
    if(productType === 'variant_product'){
      return this.selectedVariant?.[element] ? this.selectedVariant?.[element] + (element === 'sales_price' || element === 'cost' ? ' €' : '') : '--';
    } else {
      return this.product[element] ? this.product[element] + (element === 'sales_price' || element === 'cost' ? ' €' : '') : '--';
    }
  }

  /**
   * Raw field value for copy actions. Unlike `getProductElementValue`, this
   * returns null rather than the '--' placeholder, so <ui-copyable> hides the
   * copy affordance instead of putting '--' on the clipboard.
   */
  getProductElementRawValue(element: 'sku' | 'barcode'): string | number | null {
    const source: any =
      this.getProductType(this.product) === 'variant_product' ? this.selectedVariant : this.product;
    return source?.[element] ?? null;
  }

  getCurrencyPrices(priceType: 'retail_price' | 'cost'): ICurrencyPrice[] {
    const productType = this.getProductType(this.product);
    if(productType === 'variant_product'){
      return this.selectedVariant?.currency_prices?.filter(
        (price: ICurrencyPrice) => price.type === priceType && price.amount !== undefined && price.amount !== null
      ) || [];
    } else {
      return this.product.currency_prices?.filter(
        (price: ICurrencyPrice) => price.type === priceType && price.amount !== undefined && price.amount !== null
      ) || [];
    }
  }

  formatCurrencyPrice(price: ICurrencyPrice): string {
    if (!price.amount) return '--';
    const formattedAmount = price.amount.toString();
    if (price.symbol) {
      return price.position === 'before' 
        ? `${price.symbol}${formattedAmount}` 
        : `${formattedAmount} ${price.symbol}`;
    }
    return formattedAmount;
  }

  getSubElementValue(element: 'reorder_point', module: 'stock'): number | string | undefined {
    const productType = this.getProductType(this.product);
    if(productType === 'variant_product'){
      return this.selectedVariant?.[module]?.[element] ? this.selectedVariant?.[module]?.[element] : '--';
    } else {
      return this.product?.[module]?.[element] ? this.product?.[module]?.[element] : '--';
    }
  }

  getExtraIdentifiers(): string[] {
    const productType = this.getProductType(this.product);
    if(productType === 'variant_product'){
      return this.selectedVariant?.extra_identifiers || [];
    } else {
      return this.product.extra_identifiers || [];
    }
  }

  nextImage(): void {
    const images = this.getAllImages();
    if (images.length > 0) {
      this.currentImageIndex = (this.currentImageIndex + 1) % images.length;
    }
  }

  prevImage(): void {
    const images = this.getAllImages();
    if (images.length > 0) {
      this.currentImageIndex = (this.currentImageIndex - 1 + images.length) % images.length;
    }
  }

  selectImage(index: number): void {
    this.currentImageIndex = index;
  }

  onImageError(event: Event): void {
    const target = event.target as HTMLImageElement;
    if (target) {
      target.src = 'assets/images/placeholder.png';
    }
  }

  public getStatusTranslation(status: string): string {
    return this.translateService.instant(productStatusI18nKey(status)) || status;
  }

  public statusTone(product: IProduct): StatusBadgeTone {
    return productStatusTone(product.status);
  }

  public getProductType(product: IProduct): string {
    return product.variants && product.variants.length > 1 ? 'variant_product' : 'standard_product';
  }

  // Read more functionality methods
  toggleDescriptionExpansion(type: 'description' | 'technical_details') {
      if(type === 'description'){
        this.isDescriptionExpanded = !this.isDescriptionExpanded;
      } else if(type === 'technical_details'){
        this.isTechnicalDetailsExpanded = !this.isTechnicalDetailsExpanded;
      }
    }

  getDisplayDescription(): string {
    if (!this.product.description || typeof this.product.description !== 'string') return '';
    
    if (this.isDescriptionExpanded || this.product.description.length <= this.DESCRIPTION_TRUNCATE_LENGTH) {
      return this.product.description;
    }
    
    return this.product.description.substring(0, this.DESCRIPTION_TRUNCATE_LENGTH) + '...';
  }

  getDisplayTechnicalDetails(): string {
    const productType = this.getProductType(this.product);
    if(productType === 'variant_product'){
      if (this.isTechnicalDetailsExpanded || (this.selectedVariant?.technical_details && this.selectedVariant?.technical_details.length <= this.DESCRIPTION_TRUNCATE_LENGTH)) {
        return this.selectedVariant?.technical_details || '';
      }
      
      return (this.selectedVariant?.technical_details && this.selectedVariant?.technical_details.length > this.DESCRIPTION_TRUNCATE_LENGTH) ? this.selectedVariant?.technical_details.substring(0, this.DESCRIPTION_TRUNCATE_LENGTH) + '...' : this.selectedVariant?.technical_details || '';
    } else {
      if (this.isTechnicalDetailsExpanded || (this.product.technical_details && this.product.technical_details.length <= this.DESCRIPTION_TRUNCATE_LENGTH)) {
        return this.product.technical_details ?? '';
      }
      
      return (this.product.technical_details && this.product.technical_details.length > this.DESCRIPTION_TRUNCATE_LENGTH) ? this.product.technical_details.substring(0, this.DESCRIPTION_TRUNCATE_LENGTH) + '...' : this.product.technical_details || '';
    }
  }

  shouldShowReadMoreButton(type: 'description' | 'technical_details'): boolean {
    if(type === 'description'){
      return !!(this.product.description && typeof this.product.description === 'string' && this.product.description.length > this.DESCRIPTION_TRUNCATE_LENGTH);
    } else if(type === 'technical_details'){
      return !!(this.product.technical_details && typeof this.product.technical_details === 'string' && this.product.technical_details.length > this.DESCRIPTION_TRUNCATE_LENGTH);
    }
    return false;
  }

  editTechnical(): void {
    const dialogRef = this.dialog.open(DetailsTechnicalDialogEditsComponent, {
      data: this.product
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if(this.product.variants && this.product.variants.length > 1){
          this.save("variant_technical_details", result);
        } else {
          this.save("technical_details", result.technicalDetails);
        }
      }
    });
    
  }
  

  editSettings(): void {
    if (this.product.variants && this.product.variants.length > 1) {
      const dialogRef = this.dialog.open(EditVariantProductSettingsComponent, {
        data: {
          variants: this.product.variants,
        },
        disableClose: true,
      });
      dialogRef.afterClosed().subscribe((result: any) => {
        if (result) {
          this.save("variant_settings", result);
        }
      });
    } else {
      const dialogRef = this.dialog.open(DetailsSettingDialogEditsComponent, {
        data: { 
          reorder_point: this.product.stock?.reorder_point,
          max_qte: this.product.max_qte,
          min_qte: this.product.min_qte,
          increment: this.product.increment,
          translate: this.translateService
        },
        disableClose: true,
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.save("settings", result);
        }
      });
    }
  }

  editPricing(): void {
    if (this.product.variants && this.product.variants.length > 1) {
      const dialogRef = this.dialog.open(EditVariantProductPricingComponent, {
        data: {
          variants: this.product.variants,
          default_currency: this.product.default_currency
        },
        disableClose: true,
      });
      dialogRef.afterClosed().subscribe((result: any) => {
        if (result) {
          this.save("variant_pricing", result);
        }
      });
    } else {
      const dialogRef = this.dialog.open(DetailsDialogEditsPricingComponent, {
        data: {
          sales_price: this.product.sales_price,
          cost: this.product.cost,
          currencyPrices: this.product.currency_prices,
          default_currency: this.product.default_currency
        },
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.save("pricing", result);
        }
      });
    }
  }

  getCodes(): string {
    const identifiers = this.product.code_identifiers;
    
    if (!identifiers) return '--';
    
    if (Array.isArray(identifiers)) {
        const arrayIdentifiers = identifiers as any[];
        return arrayIdentifiers
            .map(item => item?.code)
            .filter(code => code && code !== '')
            .join(', ');
    }
    
    return Object.values(identifiers).join(', ');
  }

  edit_product_infos() {
    if (this.product.variants && this.product.variants.length > 1) {
      const dialogRef = this.dialog.open(EditVariantProductInfosComponent, {
        data: this.product,
        disableClose: true,
      });
      dialogRef.afterClosed().subscribe((result: any) => {
        if (result) {
          this.save("variant_basic_info", result);
        }
      });
      return;
    } else {
      const dialogRef = this.dialog.open(EditBasicProductInfosComponent, {
      data: this.product,
      disableClose: true,
      })
      dialogRef.afterClosed().subscribe((result: any) => {
        if (result) {
          this.save("basic_info", result);
        }
      });
    }
  }

  editCustomFields(): void {
    this.dialog.open(InventoryCustomFieldsComponent, {
      data: {
        objectCustomFields: this.objectCustomFields
      }
    }).afterClosed().subscribe((result: any) => {
      if (result) {
        this.saveInventoryCustomFields(result);
      }
    });
  }

  saveInventoryCustomFields(values: IObjectCustomFields['values']): void {
    this.store.dispatch(
      UpdateObjectCustomFields({
        params: { ...this.objectCustomFieldsParams },
        values,
      })
    );
  }

  async save(module:string, result: any): Promise<boolean | void>{
    let payload: any = {}
    switch (module) {
      case "basic_info":
        payload = result;
        this.store.dispatch(UpdateProduct({id:this.product.id, product: payload}))
        break;
      case "pricing":
        payload = {
          sales_price: result.sales_price,
          cost: result.cost,
          currency_prices: result.currency_prices
        };
        this.store.dispatch(UpdateProduct({id:this.product.id, product: payload}))
        break;
      case "settings":
        payload = {
          max_qte: result.max_qte,
          min_qte: result.min_qte,
          increment: result.increment,
          stock: {
            ...this.product.stock,
            reorder_point: result.reorder_point
          }
        };
        this.store.dispatch(UpdateProduct({id:this.product.id, product: payload}))
        break;
      case "images":
        this.productImages.push({
          image: result,
          default: this.productImages.length === 0
        });
        payload = {
          images: this.productImages
        };
        this.store.dispatch(UpdateProduct({id:this.product.id, product: payload}))
        break;
      case "technical_details":
        payload = {
          technical_details: result
        };
        this.store.dispatch(UpdateProduct({id:this.product.id, product: payload}))
        break;
      case "documents":
        payload = {
          files: result
        };
        this.store.dispatch(UpdateProduct({id:this.product.id, product: payload}))
        break;
      case "tags":
        payload = {
          tag_ids: result.map((tag: ITag) => tag.id)
        };
        this.store.dispatch(UpdateProduct({id:this.product.id, product: payload}))
        break;
      case "categories":
        payload = {
          category_ids: result.map((category: ICategory) => category.id)
        };
        this.store.dispatch(UpdateProduct({id:this.product.id, product: payload}))
        break;
      case "allow_oversell":
        payload = {
          can_be_sold_out_of_stock: result
        };
        this.store.dispatch(UpdateProduct({id:this.product.id, product: payload}))
        break;
      case "variant_basic_info":
        this.store.dispatch(ImproveVariantsProduct({variants: result.variants, idProduct: this.product.id, product: result.product}))
        break;
      case "variant_technical_details":
        payload = {
          variants: this.product.variants?.map((variant: IVariant) => {
            return {
              ...variant,
              values: undefined,
              code_identifiers: undefined,
              codes: undefined,
              image: undefined,
              technical_details: result.find((v: IVariant) => v.id === variant.id)?.technical_details
            }
          }) || []
        };
        this.store.dispatch(ImproveVariantsProduct({variants: payload.variants, idProduct: this.product.id}))
        break;
      case "variant_pricing":
        payload = {
          variants: this.product.variants?.map((variant: IVariant) => {
            return {
              ...variant,
              values: undefined,
              code_identifiers: undefined,
              codes: undefined,
              image: undefined,
              ...result.variants.find((v: any) => v.id === variant.id)
            }
          }) || []
        };
        this.store.dispatch(ImproveVariantsProduct({variants: payload.variants}))
        break;
      case "variant_settings":
        payload = {
          variants: this.product.variants?.map((variant: IVariant) => {
            return {
              ...variant,
              values: undefined,
              code_identifiers: undefined,
              codes: undefined,
              ...result.find((v: IVariant) => v.id === variant.id)
            }
          }) || []
        };
        this.store.dispatch(ImproveVariantsProduct({variants: payload.variants}))
        break;
    }
  }

  selectAttributeValue(attribute: string, value: string): void {
    this.selectedValues[attribute] = value;
    this.updateSelectedVariant();
  }

  isSelected(attribute: string, value: string): boolean {
    return this.selectedValues[attribute] === value;
  }

  updateSelectedVariant(): void {
    const selectedAttributes = Object.values(this.selectedValues);
    this.selectedVariant = this.product.variants?.find((variant) =>
      selectedAttributes.every((val) => variant.values.includes(val))
    );
  }

  triggerFileInput(): void {
    if (this.fileInput) {
      this.fileInput.nativeElement.click();
    }
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) return;

    const filePromises = Array.from(input.files).map((file: File) => {
      return new Promise<string>((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
          const previewData = reader.result as string;
          const base64Data = previewData.split(',')[1];
          resolve(base64Data);
        };
        reader.onerror = () => reject(reader.error);
        reader.readAsDataURL(file);
      });
    });

    Promise.all(filePromises).then((base64Images: string[]) => {
      // Track if productImages was empty before adding new images
      const wasEmpty = this.productImages.length === 0;
      
      // Add all images to productImages
      base64Images.forEach((base64Data, index) => {
        this.productImages.push({
          image: base64Data,
          default: wasEmpty && index === 0 // Only first image is default if productImages was empty
        });
      });

      // Save all images at once
      const payload: any = {
        images: this.productImages
      };
      this.store.dispatch(UpdateProduct({id: this.product.id, product: payload}));
    }).catch((error) => {
      console.error('Error reading image files:', error);
    });
    
    // Reset the input so the same files can be selected again
    input.value = '';
  }

  async deleteImage(index: number, event: Event): Promise<void> {
    event.stopPropagation(); // Prevent thumbnail click when deleting
    
    const allImages = this.getAllImages();
    if (index < 0 || index >= allImages.length) return;

    // Determine if we're deleting the main image or an image from the images array
    const hasMainImage = !!this.product.image;
    let imageIndexToDelete = -1;
    
    if (hasMainImage && index === 0) {
      // Deleting the main image
      if (this.product.images && this.product.images.length > 0) {
        // Promote the first image from images array to be the new main image
        const firstImage = this.product.images[0];
        if (typeof firstImage === 'string') {
          this.product.image = firstImage;
          this.product.images = this.product.images.slice(1);
        } else {
          // If it's an object, we can't directly use it as main image
          // Just remove the main image and keep images array as is
          this.product.image = '';
        }
      } else {
        // No other images, just clear the main image
        this.product.image = '';
      }
    } else {
      // Deleting from images array
      imageIndexToDelete = hasMainImage ? index - 1 : index;
      if (this.product.images && imageIndexToDelete >= 0 && imageIndexToDelete < this.product.images.length) {
        this.product.images = this.product.images.filter((_img: any, i: number) => i !== imageIndexToDelete);
      }
    }

    // Update currentImageIndex if needed
    const newImagesCount = this.getAllImages().length;
    if (this.currentImageIndex >= newImagesCount) {
      this.currentImageIndex = Math.max(0, newImagesCount - 1);
    }
    // If we deleted the current image, move to previous one
    if (index === this.currentImageIndex && this.currentImageIndex > 0) {
      this.currentImageIndex = this.currentImageIndex - 1;
    }

    // Build the payload array with base64 images
    const imagesPayload: { image: string; default: boolean }[] = [];
    
    // Add main image first (default: true)
    if (this.product.image) {
      try {
        let base64Image: string;
        if (this.product.image.startsWith('data:')) {
          // Already base64, extract the base64 part
          base64Image = this.product.image.split(',')[1];
        } else if (this.product.image.includes('cdn/') || this.product.image.startsWith('http')) {
          // URL, convert to base64
          const fullBase64 = await this.getBase64ImageFromUrlUsingCanvas(
            this.product.image.includes('cdn/') ? this.apiBaseUrl + this.product.image : this.product.image
          );
          base64Image = fullBase64.split(',')[1];
        } else {
          // Assume it's already base64
          base64Image = this.product.image;
        }
        imagesPayload.push({
          image: base64Image,
          default: true
        });
      } catch (error) {
        console.error('Error converting main image to base64:', error);
      }
    }
    
    // Add other images (default: false)
    if (this.product.images && Array.isArray(this.product.images)) {
      for (const img of this.product.images) {
        try {
          let base64Image: string;
          if (typeof img === 'string') {
            if (img.startsWith('data:')) {
              base64Image = img.split(',')[1];
            } else if (img.includes('cdn/') || img.startsWith('http')) {
              const fullBase64 = await this.getBase64ImageFromUrlUsingCanvas(
                img.includes('cdn/') ? this.apiBaseUrl + img : img
              );
              base64Image = fullBase64.split(',')[1];
            } else {
              base64Image = img;
            }
          } else if (img.preview) {
            if (img.preview.startsWith('data:')) {
              base64Image = img.preview.split(',')[1];
            } else if (img.preview.includes('cdn/') || img.preview.startsWith('http')) {
              const fullBase64 = await this.getBase64ImageFromUrlUsingCanvas(
                img.preview.includes('cdn/') ? this.apiBaseUrl + img.preview : img.preview
              );
              base64Image = fullBase64.split(',')[1];
            } else {
              base64Image = img.preview;
            }
          } else {
            continue; // Skip invalid images
          }
          
          imagesPayload.push({
            image: base64Image,
            default: false
          });
        } catch (error) {
          console.error('Error converting image to base64:', error);
        }
      }
    }

    // Save the updated product with the correct payload format
    const payload: any = {
      images: imagesPayload
    };
    this.store.dispatch(UpdateProduct({id: this.product.id, product: payload}));
  }

  convertImagesToBase64(images: any[]): Promise<any[]> {
    const promises = images.map(async (image) => {
      if (!image.preview.startsWith('data:')) {
        image.preview = await this.getBase64ImageFromUrlUsingCanvas(this.apiBaseUrl + image.preview)
        // .catch(() => image.preview); // If conversion fails, keep the original URL
      }
      return image;
    });

    return Promise.all(promises);
  }

  async getBase64ImageFromUrlUsingCanvas(imageUrl: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = 'anonymous'; // Use if the server supports CORS
      img.src = imageUrl;

      img.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext('2d');

        if (ctx) {
          ctx.drawImage(img, 0, 0);
          const base64 = canvas.toDataURL('image/png')
          resolve(base64); // Convert to Base64
        } else {
          reject('Canvas not supported');
        }
      };

      img.onerror = () => reject('Failed to load image');
    });
  }

  private convertBase64ToBlob(data: string, content_type: string): Blob {
    const byteCharacters = atob(data);
    const byteNumbers = new Array(byteCharacters.length)
      .fill(0)
      .map((_, i) => byteCharacters.charCodeAt(i));
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: content_type });
  }

  triggerDocumentInput(): void {
    if (this.documentInput) {
      this.documentInput.nativeElement.click();
    }
  }

  addDocument(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) return;

    const filePromises = Array.from(input.files).map((file: File) => {
      return new Promise<IFile>((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
          const base64Data = reader.result as string;
          resolve({
            data: base64Data.split(',')[1],
            filename: file.name,
            content_type: file.type,
          });
        };
        reader.onerror = () => reject(reader.error);
        reader.readAsDataURL(file);
      });
    });

    Promise.all(filePromises).then((newFiles: IFile[]) => {
      this.selectedFiles = [...this.selectedFiles, ...newFiles];
      this.save("documents", this.selectedFiles);
    }).catch((error) => {
      console.error('Error reading files:', error);
    });
  }

  removeDocument(index: number): void {
    this.selectedFiles.splice(index, 1);
    this.save("documents", this.selectedFiles);
  }

  download(data: string, fileName: string, content_type: string) {
    const blob = this.convertBase64ToBlob(data, content_type);
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.href = url;
    link.download = fileName;
    link.click();
    URL.revokeObjectURL(url);
  }

  onAllowOversellChange(event: any): void {
    this.save("allow_oversell", event.checked);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

}
